var map = {
	"./can1.png": "128c",
	"./can10.png": "3e6d",
	"./can11.png": "c542",
	"./can12.png": "ebb4",
	"./can2.png": "d879",
	"./can3.png": "d669",
	"./can4.png": "9cd9",
	"./can5.png": "6c2d",
	"./can6.png": "dcf3",
	"./can7.png": "beff",
	"./can8.png": "ddb8",
	"./can9.png": "d834"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "40d9";